import * as DLPluckingRooster from './../../../DL/Admin/Games/PluckingRooster';

const SubmitGame = async (userData, score, acceptedTerms = true, roomId = null) => {
    try {
        const payload = {
            fullName: userData.fullName,
            phoneNumber: userData.phoneNumber,
            email: userData.email,
            companionType: userData.companionType,
            score: score,
            acceptedTerms: acceptedTerms
        };

        const response = await DLPluckingRooster.SubmitGame(payload, roomId);

        if (response.success) {
            return { success: true, data: response.data };
        } else {
            let userMessage = '¡Ups! Ha habido un error con tu conexión de internet o datos móviles';
            
            if (response.status === 409) {
                userMessage = '¡Gracias por tu participación! Ya has jugado anteriormente';
            } else if (response.message) {
                userMessage = response.message;
            }

            return { success: false, message: userMessage };
        }
    } catch (e) {
        return { success: false, message: 'No ha sido posible enviar tu puntuación. Inténtalo de nuevo.' };
    }
};

const ValidatePlayer = async (email, phone, roomId = null) => {
    try {
        const response = await DLPluckingRooster.ValidatePlayer(email, phone, roomId);
        
        if (response.success) {
            return { success: true };
        } else {
            let msg = 'Error al validar tus datos.';

            if (response.status === 409) msg = '¡Gracias por tu participación! Ya has jugado anteriormente';
            
            return { success: false, message: msg };
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible validar tus datos. Inténtalo nuevamente o inténtalo más tarde' };
    }
};

const GetSettings = async (roomId = null) => {
    try {
        return await DLPluckingRooster.GetSettings(roomId);
    } catch (error) {
        return { 
            success: true, 
            data: { 
                offsetY: 0, 
                bannerMode: 'invitation', 
                winnerName: '', 
                isOverlayVisible: false, 
                isGameActive: true 
            } 
        };
    }
};

const GetAdminParticipants = async (roomId = null, search = '', page = 1, pageSize = 50) => {
    try {
        return await DLPluckingRooster.GetAdminParticipants(roomId, search, page, pageSize);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cargar el listado de participantes.' };
    }
};

const SelectWinner = async (id, roomId = null) => {
    try {
        return await DLPluckingRooster.SelectWinner(id, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al establecer el ganador.' };
    }
};

const ClearWinner = async (id, roomId = null) => {
    try {
        return await DLPluckingRooster.ClearWinner(id, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al desmarcar el ganador.' };
    }
};

const GetAdminStats = async (roomId = null) => {
    try {
        return await DLPluckingRooster.GetAdminStats(roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar obtener las estadísticas.' };
    }
};

const ShowOverlay = async (top = 10, roomId = null) => {
    // Soporte si top es pasado o si el primer arg es roomId
    let effectiveTop = 10;
    let effectiveRoomId = roomId;
    if (typeof top === 'string' && !roomId) {
        effectiveRoomId = top;
    } else if (typeof top === 'number') {
        effectiveTop = top;
    }
    return await DLPluckingRooster.ShowOverlay(effectiveTop, effectiveRoomId);
};

const HideOverlay = async (roomId = null) => {
    return await DLPluckingRooster.HideOverlay(roomId);
};

const RefreshOverlay = async (top = 10, roomId = null) => {
    let effectiveTop = 10;
    let effectiveRoomId = roomId;
    if (typeof top === 'string' && !roomId) {
        effectiveRoomId = top;
    } else if (typeof top === 'number') {
        effectiveTop = top;
    }
    return await DLPluckingRooster.RefreshOverlay(effectiveTop, effectiveRoomId);
};

const ConfigOverlay = async (layoutModeOrDto, offsetOrRoomId = null, maybeRoomId = null) => {
    let payload;
    let effectiveRoomId = null;

    if (typeof layoutModeOrDto === 'object' && layoutModeOrDto !== null) {
        payload = layoutModeOrDto;
        effectiveRoomId = offsetOrRoomId;
    } else {
        payload = { layoutMode: layoutModeOrDto, positionOffset: offsetOrRoomId };
        effectiveRoomId = maybeRoomId;
    }

    return await DLPluckingRooster.ConfigOverlay(payload, effectiveRoomId);
};

const ConfigGame = async (duration, roomId = null) => {
    const durNum = typeof duration === 'object' ? duration.durationSeconds : duration;
    if (durNum < 5) return { success: false, message: 'La duración mínima es 5 segundos' };
    return await DLPluckingRooster.ConfigGame(duration, roomId);
};

const ResetGame = async (roomId = null) => {
    return await DLPluckingRooster.ResetGame(roomId);
};

const ToggleActiveGame = async (active, roomId = null) => {
    try {
        return await DLPluckingRooster.ToggleActiveGame(active, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar el estado del juego.' };
    }
};

const UpdatePosition = async (offset, roomId = null) => {
    try {
        return await DLPluckingRooster.UpdatePosition(offset, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar desplazar la pantalla.' };
    }
};

const UpdateBannerMode = async (mode, roomId = null) => {
    try {
        return await DLPluckingRooster.UpdateBannerMode(mode, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la configuración del banner.' };
    }
};

const UpdateOverlayVisibility = async (visible, roomId = null) => {
    try {
        return await DLPluckingRooster.UpdateOverlayVisibility(visible, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al cambiar la visibilidad del overlay.' };
    }
};

const TrackMetric = async (eventName, sessionId, source, roomId = null) => {
    try {
        return await DLPluckingRooster.TrackMetric(eventName, sessionId, source, roomId);
    } catch (error) {
        return { success: false, message: 'Ocurrió un error al intentar guardar la métrica.' };
    }
};

export {
    SubmitGame,
    ValidatePlayer,
    GetSettings,
    GetAdminParticipants,
    SelectWinner,
    ClearWinner,
    GetAdminStats,
    ShowOverlay,
    HideOverlay,
    RefreshOverlay,
    ConfigOverlay,
    ConfigGame,
    ResetGame,
    ToggleActiveGame,
    UpdatePosition,
    UpdateBannerMode,
    UpdateOverlayVisibility,
    TrackMetric
};